import packageKey from './packageKey';
import { first } from '.';
import addOnKey from './addOnKey';

export default (inventory, sale) => {
  const inventoryPkgs = inventory.packages[packageKey(sale.day)] || [];

  var hasAddons = false;
  Object.keys(sale.packages).forEach(pkgId => {
    const pkg = first(inventoryPkgs, p => p.item_id == pkgId);
    if (pkg == null) return;

    const addOns = inventory.addOns[addOnKey(sale.day, pkg)] || [];
    if (addOns != null && addOns.length > 0) {
      hasAddons = true;
    }
  });

  return hasAddons;
};
